var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { baseApi } from "@madmedical/store";
const api = baseApi
    .enhanceEndpoints({
    addTagTypes: ["devices"],
})
    .injectEndpoints({
    endpoints: (build) => ({
        getDevices: build.query({
            query: (userId) => ({
                url: `collect/users/${userId}/devices`,
                method: "GET",
            }),
            providesTags: ["devices"],
        }),
        connectOauth: build.mutation({
            query: (_a) => {
                var { provider } = _a, body = __rest(_a, ["provider"]);
                return ({
                    url: `oauth/connect/${provider}`,
                    method: "POST",
                    body,
                });
            },
        }),
        disconnectOauth: build.mutation({
            query: ({ provider }) => ({
                url: `oauth/disconnect/${provider}`,
                method: "POST",
            }),
            invalidatesTags: ["devices"],
        }),
        bindDevice: build.mutation({
            query: (body) => ({
                url: "collect/devices",
                method: "POST",
                body,
            }),
            invalidatesTags: ["devices"],
        }),
        unbindDevice: build.mutation({
            query: ({ provider }) => ({
                url: `collect/devices/${provider}`,
                method: "DELETE",
            }),
            invalidatesTags: ["devices"],
        }),
        submitRawData: build.mutation({
            query: (body) => ({
                url: "collect/rawdata",
                method: "POST",
                body,
            }),
        }),
    }),
});
export const { useGetDevicesQuery, useConnectOauthMutation, useDisconnectOauthMutation, useBindDeviceMutation, useUnbindDeviceMutation, useSubmitRawDataMutation, } = api;
